// extracted by mini-css-extract-plugin
export default {"contentDefault":"contentDefault_WpNV5"};